<script lang="ts">
    export let type: 'button' | 'submit' | 'reset' = 'button';
    export let variant: 'default' | 'primary' | 'danger' | 'success' | 'warning' | 'icon' | 'page' | 'close' | 'nav' = 'default';
    export let mode: 'filled' | 'outlined' | 'text' | 'auto' = 'auto';
    export let disabled: boolean = false;
    export let fullWidth: boolean = false;

    let className = '';
    export { className as class };

    $: resolvedMode = mode === 'auto'
        ? (['primary', 'danger', 'success', 'warning'].includes(variant) ? 'filled' : 'text')
        : mode;
</script>

<button
    {type}
    {disabled}
    class="btn {className}"
    class:btn--primary={variant === 'primary'}
    class:btn--danger={variant === 'danger'}
    class:btn--success={variant === 'success'}
    class:btn--warning={variant === 'warning'}
    class:btn--icon={variant === 'icon'}
    class:btn--page={variant === 'page'}
    class:btn--close={variant === 'close'}
    class:btn--nav={variant === 'nav'}
    class:btn--filled={resolvedMode === 'filled'}
    class:btn--outlined={resolvedMode === 'outlined'}
    class:btn--text={resolvedMode === 'text'}
    class:btn--full={fullWidth}
    on:click
    {...$$restProps}
>
    <slot />
</button>
